import { createActionConst } from '../../../utils/action.utils';
const BOARDS_NAMESPACE = 'BOARDS';

export const INITIAL_BOARDS_PAGE = createActionConst(BOARDS_NAMESPACE, 'INITIAL_BOARDS_PAGE');
export const FILTER_TASKS_FREETEXT = createActionConst(BOARDS_NAMESPACE, 'FILTER_TASKS_FREETEXT');
export const FILTER_TASKS_BY_DUE_DATE = createActionConst(BOARDS_NAMESPACE, 'FILTER_TASKS_BY_DUE_DATE');
export const FILTER_TASKS_BY_MEMBER_IDS = createActionConst(BOARDS_NAMESPACE, 'FILTER_TASKS_BY_MEMBER_IDS');
